import { ValueFormField, DropdownListViewModel } from "@sitecore-jss/sitecore-jss-forms";
import { TFormDataMapByValueIdFieldName } from "../../types/sitecoreJssForm.types";

export const getDropdownFieldValueText = (fieldDetails: ValueFormField<DropdownListViewModel>, formDataMapByValueIdFieldName: TFormDataMapByValueIdFieldName) => {
    const fieldDetailsValueFieldName = fieldDetails?.valueField?.name as string;
    const fieldSelectedValue = fieldDetailsValueFieldName && formDataMapByValueIdFieldName[fieldDetailsValueFieldName]?.value;
    const fieldSelectedValueText: string | undefined = fieldSelectedValue ? fieldDetails?.model?.items?.find((item) => item?.value === fieldSelectedValue)?.text : undefined;
    return fieldSelectedValueText;
}